<template>
  <div class="w-full">
    <text-input
      type="search"
      v-model:value="inputKeyword"
      @update:value="handleInput($event);"
      :placeholder="__('labels.globalSearch.placeholder')"
    >
      <template v-slot:label></template>
    </text-input>

    <span v-html="css"></span>
  </div>
</template>

<script>
export default {
  props: {
    keyword: ''
  },
  data() {
    return {
      inputKeyword: '',
      timeout: null
    }
  },
  mounted() {
    this.inputKeyword = this.keyword;
  },
  methods: {    
    handleInput (input) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit('keyword:change', input);
      }, 300);
    }
  },
  computed : {
    css() {
      return `<style type="text/css">
      html input[type="search"]::-webkit-search-cancel-button {
        background: url('${this.$store.state.settings.url}/images/close-light-mode.svg')  no-repeat center center;
      }
      html.dark  input[type="search"]::-webkit-search-cancel-button {
        background: url('${this.$store.state.settings.url}/images/close-dark-mode.svg')  no-repeat center center;
      }</style>`
    }
  }
}
</script>

<style>
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  height: 15px;
  width: 15px;
}
</style>